import { render, staticRenderFns } from "./MagazinePage.vue?vue&type=template&id=5e258624&scoped=true"
import script from "./MagazinePage.vue?vue&type=script&lang=js"
export * from "./MagazinePage.vue?vue&type=script&lang=js"
import style0 from "./MagazinePage.vue?vue&type=style&index=0&id=5e258624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e258624",
  null
  
)

export default component.exports